import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from "rxjs/Subscription";
import { GlobalService } from '../../../../services/global.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styles: []
})
export class NavbarComponent implements OnInit {
  @Input() childSidebarToggle; // sidebar boolean
  auth;
  role;
  sideActive: boolean;
  subs: Subscription[];
  currentPath = window.location.pathname; //role path
  routeLinkUrl = "";

  constructor(    
    private authService: AuthService,
    private router: Router,
    private globalService : GlobalService,
  ) {
    this.currentPath = this.currentPath.substring(1, this.currentPath.indexOf('/', 1));
    this.subs = [];
    this.subs.push(
      this.globalService.sideBar$.subscribe(
        res => {
          this.sideActive = res;
        }
      )
    );
 }

   ngOnInit() {
    if (this.childSidebarToggle != undefined) {
      this.routeLinkUrl = "/" + this.authService.role + "/dashboard";
    } else {
      this.routeLinkUrl = (this.currentPath == "student") ? '/student/login' : '/login';
    }
   //this.globalService.update(true);
    
  }
  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {
      sub.unsubscribe()
    });
  }
  
  changeSidebar(){
    this.globalService.update(!this.sideActive);
    
  }

  logOut(){
    if(confirm("ログアウトしますか？")) {
      this.auth = this.authService.deleteAuth();
      if(!this.auth){
        this.router.navigate(['/login']); // Navigate to dashboard view
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/component/elements/navigation/navbar/navbar.component.ts